import { Typography } from "antd";
import PageLayout from "components/molecules/PageLayout";
import Lineage from "containers/Lineage";
import { useParams } from "react-router-dom";

const LineagePage = (props) => {
    const { tenant } = useParams();
    return (
        <PageLayout
            mainContent={({ setBreadcrumbNavigationItems }) => {
                return <Lineage setBreadcrumbNavigationItems={setBreadcrumbNavigationItems} tenant={tenant}></Lineage>;
            }}
            helpContent={<Typography>We're working on this documentation.</Typography>}
        ></PageLayout>
    );
};

export default LineagePage;
